module.exports = __webpack_public_path__ + "static/img/m_role.f9768e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/bz/m_role.png
// module id = hoSd
// module chunks = 7